import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Container, Segment } from 'semantic-ui-react';

import { getTitlePrefix } from '../config/env';
import { PAGE_NAMES, useSegmentPage } from '../segment';
import { FeatureFlagsTable } from './FeatureFlagsTable';

export const FeatureFlagsPage = () => {
  const { t } = useTranslation();
  useSegmentPage(PAGE_NAMES.featureFlags);

  const renderPageHead = () => (
    <Helmet>
      <title>
        {getTitlePrefix()}
        {t('featureFlags.page.browserTitle')}
      </title>
      <body className="feature-flags" />
    </Helmet>
  );

  return (
    <Container className="no-padding no-margin">
      {renderPageHead()}
      <Segment basic>
        <FeatureFlagsTable />
      </Segment>
    </Container>
  );
};
